<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.domain.parking-card.title"></app-title-bar>
<div class="row">
  <div class="col-4">
    <div class='d-lg-flex align-items-center mb-3 e-btn-group'>
      <input type="radio" id="issuedbyMe" name="assignment" [value]="false" [(ngModel)]="issuedToMe" (change)="changeView()" />
      <label class="e-btn p-0" for="issuedbyMe">{{ 'i18n.domain.parking-card.issued-by-me-label' | translate}}</label>
      <input type="radio" id="issuedToMe" name="assignment" [value]="true" [(ngModel)]="issuedToMe" (change)="changeView()" />
      <label class="e-btn p-0" for="issuedToMe">{{ 'i18n.domain.parking-card.issued-to-me-label' | translate}}</label>
    </div>
  </div>
</div>
<app-parking-card-grid [isAdmin]="false" [issuedToMe]="issuedToMe" #gridComponent></app-parking-card-grid>
